import React from 'react';
import { InputLabel } from '@material-ui/core';

const CustomInputLabel = (props) => <InputLabel shrink={false} {...props} />;
export default CustomInputLabel;
